/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import DropDownComponent from "./DropDownComponent";
import moment from "moment";
import { dataService } from "../../../../../services/data.services";
import { distributeAmounts, distributeDivision } from "./distributeDivisionFeeTerm";
import { formatAdjustedDate } from "../../../../../CommonMethods/formatDate";
import { ShimmerTitle } from 'react-shimmer-effects'

const FeeStructure = ({
    showDropdown,
    submitSelected,
    feeStructureLoading,
    studentDetails,
    setStudentDetails,
    branch_id,
    feeStructure, 
    selectedFeeTermData, 
    getFeeStructure,
    customError,
    setSelectedFeeTermData,
    selectedDropDownValue,
    setSelectedDropDownValue,
    setDidDropDownChange,
    didAcademicDropDownChange,
    didDropDownChange,
    hasStartDateBegun,
    setHasStartDateBegun,
    edit,
    selectedObjects,
    isSelectFeeTermDropdown, 
    setIsSelectFeeTermDropdown
}) => {
    const [feeTerm, setFeeTerm] = useState([])
    const [selectedTermLength, setSelectedTermLength] = useState(feeTerm[0]?.number_of_fee_terms);
    const [totalAmountOptionalSubjects, setTotalAmountOptionalSubjects] = useState(0);

    const feeHeadLookup = studentDetails?.fee_structure?.fee_head?.reduce((acc, feeHead) => {
        if (feeHead?.fee_head_id) {
            acc[feeHead.fee_head_id] = feeHead?.feehead_name || '';
        }
        return acc;
    }, {}) || {};

    const getFeeHeadName = (fee) => (
        fee?.feehead_name
        || feeHeadLookup?.[fee?.fee_head_id]
        || '-'
    );

    const formatAmount = (value) => {
        const parsedValue = parseFloat(value);
        return Number.isFinite(parsedValue) ? parsedValue.toFixed(2) : '-';
    };
    
    /* The above code is a useEffect hook in a React component. It is used to perform certain actions
    when the component mounts or when specific dependencies change. */
    useEffect(()=>{
        getFeeTerm();
        if(edit && selectedDropDownValue){
            let startDate = '';
            if(didDropDownChange){
                startDate = new Date(selectedFeeTermData?.terms[0]?.start_date);
                setSelectedTermLength(selectedFeeTermData?.number_of_fee_terms);
            } else{
                startDate = new Date(selectedFeeTermData?.fee_term[0]?.start_date);
                setSelectedTermLength(selectedFeeTermData?.fee_term?.length);
            }
            if(!isSelectFeeTermDropdown) {
                if (startDate !== '' && studentDetails?.has_invoice) {
                    setHasStartDateBegun(true);
                } else {
                    setHasStartDateBegun(false);
                } 
            }  
        }
        if (selectedObjects) {
            calculateTotalAmount();
        }
    },[didDropDownChange, selectedObjects, feeStructureLoading])
    
    /* The above code is using the useEffect hook in a React component. It is checking if the value of
    the variable "didAcademicDropDownChange" has changed, and if so, it sets the value of
    "setSelectedDropDownValue" to an empty string. This is likely used to reset the selected value
    in a dropdown menu when the "didAcademicDropDownChange" variable changes. */
    useEffect(()=>{
        didAcademicDropDownChange && setSelectedDropDownValue('')
    },[didAcademicDropDownChange])

    /**
     * The function `getFeeTerm` is an asynchronous function that retrieves fee terms from an API and
     * sets the retrieved data to the `FeeTerm` state variable.
     */
    const getFeeTerm = async()=>{
        if(feeStructureLoading) return
        let endpoint = `feeterms?branch_id=${branch_id}&academic_year=${studentDetails.academic_year.name}&filter=true&status=true&role=directory`;
        const response = await dataService.GetAPI(endpoint, true)
        const temp=(response.data?.data?.data)
        setFeeTerm(temp)
        const apiFeeTerm = temp.find(term => term._id === studentDetails.fee_term_id);
        if (apiFeeTerm === undefined) {
            if (!studentDetails?.has_invoice) {
                setSelectedDropDownValue('');
                setSelectedFeeTermData({});
                setSelectedTermLength(0);
                setStudentDetails(prev => {
                    const { fee_term_id, ...rest } = prev;
                    return rest;
                });
            }
        }
        if (studentDetails.fee_term_id) {
            // Find the fee term based on fee_term_id
            if(apiFeeTerm !== undefined && !hasStartDateBegun){
                setDidDropDownChange(true)
                setSelectedDropDownValue(apiFeeTerm?.fee_term_name);
                setSelectedFeeTermData(apiFeeTerm);
                setSelectedTermLength(apiFeeTerm?.number_of_fee_terms);
            }
        }
    }

    /**
     * The function calculates the total amount by summing up the amounts of selected objects and sets
     * the total amount for optional subjects.
     */
    const calculateTotalAmount = () => {
        const total = selectedObjects.reduce((accumulator, item) => {
            return accumulator + parseFloat(item.amount);
        }, 0);

        setTotalAmountOptionalSubjects(total.toFixed(2));
    };

    /**
     * The function `handleDropDownValue` updates various state variables based on the selected
     * dropdown value.
     */
    const handleDropDownValue = (key, item)=>{
        setSelectedDropDownValue(item?.fee_term_name)
        setSelectedFeeTermData(item)
        setSelectedTermLength(item?.number_of_fee_terms);   
        setDidDropDownChange(true)
        setHasStartDateBegun(false);
        setIsSelectFeeTermDropdown(true);
        setStudentDetails(prev => ({
            ...prev,
            fee_term_id: item?._id
        }));
    }
    useEffect(()=>{
        getFeeStructure()
    },[])

    return (
        <div class="mb-8">
            <div className="border border-[#D0D5DD] p-3 rounded" >
                <div className="flex justify-between">
                    <div className="w-[60%]">
                        <div className="flex pb-3">
                            <p className="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Academic Year</p>
                            <p className="text-f7 font-semibold text-[#031624] min-w-[138px] inline-flex">{studentDetails.academic_year.name === "" ? ""  : `${studentDetails.academic_year.name} (${moment(studentDetails.academic_year.start_date.split('T')[0]).format("MMM DD, YYYY")}-${moment(studentDetails.academic_year.end_date.split('T')[0]).format("MMM DD, YYYY")}) `}</p>
                        </div>
                        <div className="flex pb-3">
                            <p className="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Class</p>
                            <p className="text-f7 font-semibold text-[#031624] min-w-[138px] inline-flex">{studentDetails.classes.class_name}</p>
                        </div>
                        <div className="flex pb-3">
                            <p className="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Section</p>
                            <p className="text-f7 font-semibold text-[#031624] min-w-[138px] inline-flex">{studentDetails.sections.section_name}</p>
                        </div> 
                    </div>
                    {feeStructureLoading ? 
                    //Shimmer if the api is still loading
                        <div className="w-[40%] mr-4">
                            <p className="font-semibold">Fee Structure</p>
                            <div className="flex flex-col justify-between border border-[#D0D5DD] p-1 rounded">
                                <div className="h-[100px] px-2">
                                    <p className="text-2xl font-bold text-[#031624] mb-4"><ShimmerTitle line={1} gap={6} variant="secondary" className="w-[270px]"/></p>
                                    <p className="text-2xl font-bold text-[#031624] mb-4"><ShimmerTitle line={1} gap={6} variant="secondary" className="w-[270px]"/></p>
                                    <p className="text-2xl font-bold text-[#031624] mb-1"><ShimmerTitle line={1} gap={6} variant="secondary" className="w-[270px]"/></p>
                                </div>
                                <hr></hr>
                                <div className="flex pt-[10px] px-2">
                                    <p className="text-f7 font-normal text-[#031624] w-1/2 inline-flex">Academic Fee</p>
                                    <p className="flex justify-center items-center text-2xl font-bold text-[#031624]"><ShimmerTitle line={1} variant="secondary" className="w-[150px]"/></p>
                                </div>
                            </div>
                        </div> 
                        : didAcademicDropDownChange ? (
                        // Case 1: didAcademicDropDownChange is true
                            feeStructure?.length !== 0 ||  studentDetails?.fee_structure === 0 ? (
                            // Case 1.1: feeStructure is not empty, map feeStructure
                                <div className="w-[40%] mr-4">
                                    <p className="pb-2 font-semibold">Fee Structure</p>
                                    <div className="flex flex-col justify-between border border-[#D0D5DD] p-1 rounded">
                                        <div className="h-[100px] overflow-y-auto scroll-bar px-2">
                                            {feeStructure[0]?.fees.map((fee) => (
                                                <div key={fee?.fee_head_id} className="flex">
                                                    <p className="text-f7 py-1 font-normal text-[#031624] w-1/2 inline-flex">
                                                        {fee?.fee_head}
                                                    </p>
                                                    <p className="text-f7 py-1 text-end font-normal text-[#031624] w-1/2">
                                                        {parseFloat(fee?.amount).toFixed(2)}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                        <hr></hr>
                                        <div className="flex pt-[10px] px-2">
                                            <p className="text-f7 font-normal text-[#031624] w-1/2 inline-flex">Academic Fee</p>
                                            <p className="text-f7 text-end font-semibold text-[#031624] w-1/2">
                                                {(parseFloat(feeStructure[0]?.cumulative_amount)).toFixed(2)}{' '}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                            // Case 1.2: feeStructure is empty, show no fee structure found message
                                <div className="w-[40%] mr-4">
                                    <p className="pb-2 font-semibold">Fee Structure</p>
                                    <div className="flex justify-center items-center border border-[#D0D5DD] p-6 my-2 rounded">
                                        <p>No fee structure found, please add the fee structure for the current AY and class</p>
                                    </div>
                                </div>
                            )
                        ) : studentDetails?.fee_structure === undefined ? (
                        // Case 2: studentDetails.fee_structure is undefined, show no fee structure found message
                            <div className="w-[40%] mr-4">
                                <p className="pb-2 font-semibold">Fee Structure</p>
                                <div className="flex justify-center items-center border border-[#D0D5DD] p-6 my-2 rounded">
                                    <p>No fee structure found, please add the fee structure for the current AY and class</p>
                                </div>
                            </div>
                        ) : studentDetails?.fee_structure === null  ? (
                        // Case 3: studentDetails.fee_structure is null
                            feeStructure?.length !== 0 ? (
                            // Case 3.1: feeStructure is not empty, map feeStructure
                                <div className="w-[40%] mr-4">
                                    <p className="pb-2 font-semibold">Fee Structure</p>
                                    <div className="flex flex-col justify-between border border-[#D0D5DD] p-1 rounded">
                                        <div className="h-[100px] overflow-y-auto scroll-bar px-2">
                                            {feeStructure[0]?.fees.map((fee) => (
                                                <div key={fee?.fee_head_id} className="flex">
                                                    <p className="text-f7 py-1 font-normal text-[#031624] w-1/2 inline-flex">
                                                        {fee?.fee_head}
                                                    </p>
                                                    <p className="text-f7 py-1 text-end font-normal text-[#031624] w-1/2">
                                                        {parseFloat(fee?.amount).toFixed(2)}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                        <hr></hr>
                                        <div className="flex pt-[10px] px-2">
                                            <p className="text-f7 font-normal text-[#031624] w-1/2 inline-flex">Academic Fee</p>
                                            <p className="text-f7 text-end font-semibold text-[#031624] w-1/2">
                                                {(parseFloat(feeStructure[0]?.cumulative_amount)).toFixed(2)}{' '}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                            // Case 3.2: feeStructure is empty, show no fee structure found message
                                <div className="w-[40%] mr-4">
                                    <p className="pb-2 font-semibold">Fee Structure</p>
                                    <div className="flex justify-center items-center border border-[#D0D5DD] p-6 my-2 rounded">
                                        <p>No fee structure found, please add the fee structure for the current AY and class</p>
                                    </div>
                                </div>
                            )
                        ) : (
                        // Case 4: studentDetails.fee_structure has a value other than undefined or null, map studentDetails.fee_structure
                            <div className="w-[40%] mr-4">
                                <p className="pb-2 font-semibold">Fee Structure</p>
                                <div className="flex flex-col justify-between border border-[#D0D5DD] p-1 rounded">
                                    <div className="h-[100px] overflow-y-auto scroll-bar px-2">
                                        {studentDetails?.fee_structure?.fee_head?.map((fee, index) => (
                                            <div key={index} className="flex">
                                                <p className="text-f7 py-1 font-normal text-[#031624] w-1/2 inline-flex">
                                                    {fee?.feehead_name}
                                                </p>
                                                <p className="text-f7 py-1 text-end font-normal text-[#031624] w-1/2">{parseFloat(fee?.feehead_amount).toFixed(2)}</p>
                                            </div>
                                        ))}
                                    </div>
                                    <hr></hr>
                                    <div className="flex pt-[10px] px-2">
                                        <p className="text-f7 font-normal text-[#031624] w-1/2 inline-flex">Academic Fee</p>
                                        <p className="text-f7 text-end font-semibold text-[#031624] w-1/2">
                                            {(parseFloat(studentDetails?.fee_structure?.total_amount)).toFixed(2)}{' '}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                </div>
            </div>
            <div className="border border-[#D0D5DD] rounded mr-4 mt-6 mb-3 w-full">
                <div className="">
                    <div className="flex items-center bg-[#EEF7FE] py-3 w-full rounded">
                        <label class="text-f2 px-4 font-normal text-[#031624] min-w-[118px] inline-flex">Select Fee Term</label>
                        <DropDownComponent
                            divClassName={'relative w-[25%] 2xl:w-[20%]'} 
                            showErrorBorder={customError.includes("fee-term")}
                            /*Need to discuss this-Anitha.
                            className={`w-full border ${customError.includes("fee-term") ? 'border-[#312c2b]' : 'border-[#D0D5DD]'} rounded py-1.5 px-3.5 outline-0 text-f7 text-[#031624] text-left font-normal transition duration-150 ease-in-out error_border ${edit && hasStartDateBegun ? ' bg-[#E6E8EA] shadow-s12':'bg-white '}`}*/
                            options={feeTerm}
                            dropdownkey={selectedDropDownValue}
                            submitSelected={submitSelected}
                            handleDropDownValue={handleDropDownValue}
                            showDropdown={showDropdown}
                            placeholder={"Select Term"}
                            displayAbove={true}
                            obj={"fee_term_name"}
                            selectedvalue={selectedDropDownValue}
                            applyBGForDisabled={true}
                            stateStatus={
                                (
                                    hasStartDateBegun || 
                                  (
                                      (edit && (feeStructure?.length === 0 || studentDetails?.fee_structure === 0)) ||
                                    (!edit && feeStructure?.length === 0)
                                  )
                                )
                            }
                        />
                    </div>
                </div>
                <div className="px-4 mt-4">
                    {/* No Dropdown Selected */}
                    {!selectedDropDownValue && (
                        <div className="flex justify-evenly">
                            <p className="p-8 mb-8 min-h-[200px] text-center">
                                Select a Fee Term to view the breakdown of Fee Structure
                            </p>
                        </div>
                    )}

                    {/* Dropdown Selected */}
                    {selectedDropDownValue && (
                        <div className={`flex flex-wrap -mx-2`}>
                            {/* Check if in edit mode and dropdown has changed */}
                            {edit ? (
                                didDropDownChange ? (
                                    // Edit Mode with Dropdown Changed - Show future terms if any
                                    selectedFeeTermData?.terms?.length === 0 ? (
                                        <div className="flex justify-center items-center w-full">
                                            <p className="p-8 text-center">
                                                No Terms available.
                                            </p>
                                        </div>
                                    ) : (
                                        selectedFeeTermData?.terms?.map((term, originalIndex) => {
                                            const isFutureTerm = moment(term?.end_date.split("T")[0]).isSameOrAfter(moment());
                                            const isBeforeDoa = moment(term?.end_date.split("T")[0]) > moment(studentDetails.date_of_admission);
                                            // if (!isFutureTerm) return null; // Skip past terms if dropdown has changed and it's not in edit mode

                                            return (
                                                <div className="w-[50%] px-2" key={originalIndex}>
                                                    <div className="flex flex-col justify-between overflow-y-auto scroll-bar border border-[#D0D5DD] p-2 mb-3 rounded w-full relative">

                                                        <div>
                                                            {!isFutureTerm && (
                                                                <p className="custom-label">
                                                                    Past Term – Not Billable
                                                                </p>
                                                            )}
                                                            {isFutureTerm && !isBeforeDoa && (
                                                                <p className="custom-label">
                                                                    DOA beyond Term – Not Billable
                                                                </p>
                                                            )}
                                                            <p className="font-semibold px-2">
                                                                Term {originalIndex + 1} ({moment(term.start_date.split("T")[0]).format("MMM DD, YYYY")} -{" "}
                                                                {moment(term?.end_date.split("T")[0]).format("MMM DD, YYYY")})
                                                            </p>

                                                            <div className="min-h-[100px]  p-2">
                                                                {feeStructure[0]?.fees.map((fee) => (
                                                                    <div key={fee.fee_head_id} className="flex">
                                                                        <p className="text-f7 py-1 font-normal text-[#171a1d] w-1/2 inline-flex">
                                                                            {fee.fee_head}
                                                                        </p>
                                                                        <p className="text-f7 py-1 text-end font-normal text-[#031624] w-1/2">
                                                                            {parseFloat(distributeDivision(fee.amount, selectedTermLength, selectedTermLength)[originalIndex]).toFixed(2) || "-"}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <hr></hr>
                                                        </div>
                                                        <div className="flex justify-items-end pt-[5px] px-2">
                                                            <p className="text-f7 py-1 font-normal text-[#031624] w-1/2 inline-flex">Term Fee</p>
                                                            <p className="text-f7 py-1 text-end font-semibold text-[#031624] w-1/2">
                                                                {parseFloat(distributeAmounts(feeStructure[0]?.fees, selectedTermLength, "amount", originalIndex)).toFixed(2) || "-"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )
                                ) : (
                                    // Edit Mode with Dropdown Unchanged - Show the original data
                                    selectedFeeTermData?.fee_term?.map((term, index) => (
                                        <div className="w-[50%] px-2" key={index}>
                                            <div className="flex flex-col justify-between overflow-y-auto scroll-bar border border-[#D0D5DD] p-2 mb-3 rounded w-full">
                                                <div>
                                                    <p className="font-semibold px-2">
                                                        {term?.term_name} ({moment(term.start_date.split("T")[0]).format("MMM DD, YYYY")} -{" "}
                                                        {moment(term?.end_date.split("T")[0]).format("MMM DD, YYYY")})
                                                    </p>
                                                    <div className="min-h-[72px] px-2">
                                                        {term?.fee_head?.map((fee, feeIndex) => (
                                                            <div key={feeIndex} className="flex">
                                                                <p className="text-f7 py-1 font-normal text-[#031624] w-1/2 inline-flex">
                                                                    {getFeeHeadName(fee)}
                                                                </p>
                                                                <p className="text-f7 py-1 text-end font-normal text-[#031624] w-1/2">
                                                                    {formatAmount(fee?.feehead_amount ?? fee?.amount)}
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <hr></hr>
                                                </div>
                                                <div className="flex justify-items-end pt-[5px] px-2">
                                                    <p className="text-f7 py-1 font-normal text-[#031624] w-1/2 inline-flex">Term Fee</p>
                                                    <p className="text-f7 py-1 text-end font-semibold text-[#031624] w-1/2">
                                                        {formatAmount(term?.total_amount)}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )
                            ) : (
                            // Non-edit Mode/Add mode
                                selectedFeeTermData?.terms?.length === 0
                                    ? (<div className="flex justify-center items-center w-full">
                                        <p className="p-8 text-center">
                                            No Terms available.
                                        </p>
                                    </div>
                                    ) : (
                                        selectedFeeTermData?.terms.map((term, originalIndex) => {
                                            const isFutureTerm = moment(term?.end_date.split("T")[0]).isSameOrAfter(moment());
                                            const isBeforeDoa = moment(term?.end_date.split("T")[0]) > moment(studentDetails.date_of_admission);
                                            // if (!isFutureTerm) return null; // Skip past terms

                                            return (
                                                <div className="w-[50%] px-2" key={originalIndex}>
                                                    <div className="flex flex-col justify-between overflow-y-auto scroll-bar border border-[#D0D5DD] p-2 mb-3 rounded w-full relative">
                                                        <div>
                                                            {!isFutureTerm && (
                                                                <p className="custom-label">
                                                                    Past Term – Not Billable
                                                                </p>
                                                            )}
                                                            {isFutureTerm && !isBeforeDoa && (
                                                                <p className="custom-label">
                                                                    DOA beyond Term – Not Billable
                                                                </p>
                                                            )}
                                                            <p className="font-semibold px-2">
                                                                Term {originalIndex + 1} ({moment(term.start_date.split("T")[0]).format("MMM DD, YYYY")} -{" "}
                                                                {moment(term?.end_date.split("T")[0]).format("MMM DD, YYYY")})
                                                            </p>
                                                            <div className="h-[100px] overflow-y-auto scroll-bar p-2">
                                                                {feeStructure[0]?.fees.map((fee) => (
                                                                    <div key={fee.fee_head_id} className="flex">
                                                                        <p className="text-f7 py-1 font-normal text-[#171a1d] w-1/2 inline-flex">
                                                                            {fee.fee_head}
                                                                        </p>
                                                                        <p className="text-f7 py-1 text-end font-normal text-[#031624] w-1/2">
                                                                            {parseFloat(distributeDivision(fee.amount, selectedTermLength, selectedTermLength)[originalIndex]).toFixed(2) || "-"}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <hr></hr>
                                                        </div>
                                                        <div className="flex justify-items-end pt-[5px] px-2">
                                                            <p className="text-f7 font-normal text-[#031624] w-1/2 inline-flex">Term Fee</p>
                                                            <p className="text-f7 text-end font-semibold text-[#031624] w-1/2">
                                                                {parseFloat(distributeAmounts(feeStructure[0]?.fees, selectedTermLength, "amount", originalIndex)).toFixed(2) || "-"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )
                            )}
                        </div>
                    )}
                </div>

            </div>
        </div>
    )
}
export default FeeStructure;
